import React from 'react';
import { InteractiveShape } from '../interactive/InteractiveShape';
import shapeTypes from '../../../constants/ShapeConstants';
import { Character } from '../shapes/Character';
import { Image } from '../shapes/Image';
import { Rectangle } from '../shapes/Rectangle';
import { Triangle } from '../shapes/Triangle';
import { Star } from '../shapes/Star';
import { Heart } from '../shapes/Heart';
import { Ellipse } from '../shapes/Ellipse';
import { Line } from '../shapes/Line';
import { Curve } from '../shapes/Curve';
import { Freehand } from '../shapes/Freehand';
import { TextBox } from '../shapes/TextBox';
import { TextBoxSimple } from '../shapes/TextBoxSimple';
import { SpeakBubble } from '../shapes/SpeakBubble';
import { ThoughtBubble } from '../shapes/ThoughtBubble';
import { ScreamBubble } from '../shapes/ScreamBubble';
import { TextBoxRich } from '../shapes/TextBoxRich';
import { TextBoxSimpleRich } from '../shapes/TextBoxSimpleRich';
import { SpeakBubbleRich } from '../shapes/SpeakBubbleRich';
import { ThoughtBubbleRich } from '../shapes/ThoughtBubbleRich';
import { ScreamBubbleRich } from '../shapes/ScreamBubbleRich';
import { Video } from '../shapes/Video';
import { ComplexSpeakBubble } from './ComplexSpeakBubble';
import { ComplexSpeakBubbleRich } from './ComplexSpeakBubbleRich';
import storeManager from '../../../store/StoreManager';
import { hideMenus, setContextTarget } from '../../../actions/MenuActions';
import menuType from '../../../constants/MenuType';
import mouseUtils from '../../utils/MouseUtils';
import { selectShape } from '../../../actions/CurrentSlideActions';

export const Group = React.createClass({
    propTypes: {
        dispatch: React.PropTypes.func.isRequired,
        shapeModel: React.PropTypes.object.isRequired
    },
    isShapeSelected() {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var i;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].uuid == this.props.shapeModel.uuid) {
                if (shapes[i].isSelected == true)
                    return true;
                else
                    return false;
            }

        return false;
    },
    onKeyDown(e) {
        if (e.keyCode == 13) { // ENTER
            setTimeout(function() {
                this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
                this.props.dispatch(setContextTarget(this.props.shapeModel));

                setTimeout(function() {
                    var buttonMenu = document.getElementById('shapeMenuFirstElement');

                    if (buttonMenu)
                        buttonMenu.focus();
                }.bind(this), 20);
            }.bind(this), 20);
        }
    },
    onFocusHandler() {
        if (document.activeElement == this.refs.focusableElement) {
            if (!this.isShapeSelected())
                this.props.dispatch(selectShape(this.props.shapeModel.uuid));

            mouseUtils.activeElement = this.props.shapeModel.uuid;
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties)
            return true;
        else
            return false;
    },
    render() {
        const { shapeModel, dispatch } = this.props;

        var shapes = shapeModel.shapes.map((shape, index) => {
            switch(shape.type) {
                case shapeTypes.CHARACTER:
                    return <Character shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.IMAGE:
                    return <Image shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.RECTANGLE:
                    return <Rectangle shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.TRIANGLE:
                    return <Triangle shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.STAR:
                    return <Star shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.HEART:
                    return <Heart shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.ELLIPSE:
                    return <Ellipse shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.LINE:
                    return <Line shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.CURVE:
                    return <Curve shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.FREEHAND:
                    return <Freehand shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

                case shapeTypes.TEXTBOX: {
                    if (shape.isRichText)
                        return <TextBoxRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                    else
                        return <TextBox shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                }

                case shapeTypes.TEXTBOXSIMPLE: {
                    if (shape.isRichText)
                        return <TextBoxSimpleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                    else
                        return <TextBoxSimple shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                }

                case shapeTypes.SPEAK_BUBBLE: {
                    if (shape.isRichText)
                        return <SpeakBubbleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                    else
                        return <SpeakBubble shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                }

                case shapeTypes.COMPLEX_SPEAK_BUBBLE: {
                    if (shape.isRichText)
                        return <ComplexSpeakBubbleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                    else
                        return <ComplexSpeakBubble shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                }

                case shapeTypes.THOUGHT_BUBBLE: {
                    if (shape.isRichText)
                        return <ThoughtBubbleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                    else
                        return <ThoughtBubble shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                }

                case shapeTypes.SCREAM_BUBBLE: {
                    if (shape.isRichText)
                        return <ScreamBubbleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                    else
                        return <ScreamBubble shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                }

                case shapeTypes.VIDEO: {
                    return <Video shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                }

                case shapeTypes.GROUP: {
                    return <Group shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                }
            }
        });

        return (
            <InteractiveShape shapeModel={shapeModel} dispatch={dispatch} rotatable={true} scaleProperties={this.props.scaleProperties}>
                <g transform={`translate(${shapeModel.x} ${shapeModel.y})`} opacity={shapeModel.opacity}>
                    {shapes}
                    <rect
                        x={0}
                        y={0}
                        width={shapeModel.width}
                        height={shapeModel.height}
                        fill="none"
                        stroke={shapeModel.stroke}
                        strokeWidth={shapeModel.strokeWidth}
                        strokeOpacity={shapeModel.strokeOpacity}
                    />
                    <foreignObject>
                        <a id={'interactiveElement_' + this.props.shapeModel.uuid} href='' ref='focusableElement' onFocus={this.onFocusHandler} onKeyDown={this.onKeyDown}></a>
                    </foreignObject >
                </g>
            </InteractiveShape>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/Group.js
 **/